import template from './scq-diagram-dnd-framework.html';
import controller from './scq-diagram-dnd-framework.controller';

let scqDiagramComponent = {
  bindings: {
    data: '<',
    onComplete: '<'
  },
  controllerAs: 'vm',
  template,
  controller
};

export default scqDiagramComponent;



// WEBPACK FOOTER //
// ./client/app/components/scq-diagram-dnd-framework/scq-diagram-dnd-framework.component.js